"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Link = _interopRequireDefault(require("../Link"));
var _couponBox = _interopRequireDefault(require("./couponBox.proptypes"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const CouponContainer = _styledComponents.default.div.withConfig({
  displayName: "CouponBox__CouponContainer",
  componentId: "sc-1v335sp-0"
})(["width:256px;height:48px;display:flex;flex-direction:row;align-items:center;border:1px dashed #d9dbe0;border-radius:4px;padding:4px 12px;box-sizing:border-box;"]);
CouponContainer.displayName = 'CouponContainer';
const CouponContent = _styledComponents.default.div.withConfig({
  displayName: "CouponBox__CouponContent",
  componentId: "sc-1v335sp-1"
})(["display:flex;flex-direction:column;width:100%;"]);
CouponContent.displayName = 'CouponContent';
const CouponBox = props => {
  const {
    theme,
    accessible,
    couponCode,
    labelText,
    labelColor,
    labelSize,
    couponTextColor,
    couponTextSize,
    ctaLinkText,
    ctaLinkColor,
    ctaLinkUnderlined,
    ctaLinkHoverColor,
    ctaLinkHoverUnderlined,
    ctaLinkCallback,
    updateGtmId,
    ctaLinkHref,
    ctaLinkTarget
  } = props;
  const copyContent = () => {
    navigator.clipboard.writeText(couponCode);
  };
  let callback;
  let href;
  let target;
  if (ctaLinkHref !== undefined && ctaLinkHref !== '') {
    href = ctaLinkHref;
    target = ctaLinkTarget;
  } else {
    callback = copyContent;
    if (ctaLinkCallback !== undefined) {
      callback = ctaLinkCallback;
    }
    // eslint-disable-next-line no-script-url
    href = 'javascript:void(0);';
    target = 'callback';
  }
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const labelProps = {
    type: labelSize,
    color: labelColor,
    accessible
  };
  const couponTextProps = {
    type: couponTextSize,
    color: couponTextColor,
    accessible
  };
  const linkProps = {
    color: ctaLinkColor,
    underlined: ctaLinkUnderlined,
    hoverColor: ctaLinkHoverColor,
    hoverUnderlined: ctaLinkHoverUnderlined,
    callback,
    href,
    target,
    accessible
  };
  const getMain = () => {
    return /*#__PURE__*/_react.default.createElement(CouponContainer, null, /*#__PURE__*/_react.default.createElement(CouponContent, null, /*#__PURE__*/_react.default.createElement(_Text.default, labelProps, labelText), /*#__PURE__*/_react.default.createElement(_Text.default, couponTextProps, couponCode)), /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, linkProps, {
      linkname: "couponBoxCta",
      updateGtmId: updateGtmId
    }), ctaLinkText));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
CouponBox.propTypes = _couponBox.default.PropTypes;
CouponBox.defaultProps = _couponBox.default.DefaultProps;
var _default = exports.default = CouponBox;